var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_778_8149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0218453 28.2596C0.0218453 24.0721 -0.0328208 19.8738 0.0437118 15.6863C0.0874447 13.3576 0.306109 11.0288 1.16983 8.7984C2.08823 6.43682 3.57515 4.52351 5.54313 2.99286C7.69697 1.32007 10.1788 0.489148 12.8903 0.248617C17.1979 -0.144979 21.5056 0.0846186 25.8243 0.0408857C30.3397 -0.00284724 34.8551 0.0190192 39.3815 0.0408857C41.3604 0.0518189 43.3393 0.128352 45.2745 0.576614C47.3955 1.07954 49.3198 1.987 50.9816 3.39739C53.3323 5.39817 54.7973 7.93468 55.4752 10.9304C55.7048 11.9581 55.836 13.0077 55.8688 14.0573C56.1202 22.8695 55.9781 31.6817 55.9453 40.4938C55.9344 43.2599 55.6173 46.037 54.2288 48.5626C52.1515 52.3236 49.0136 54.6524 44.8262 55.5489C43.2081 55.8988 41.5572 55.9862 39.9063 55.9862C31.7501 56.0081 23.583 56.03 15.4268 55.9753C12.6716 55.9534 9.94922 55.5926 7.46737 54.2588C3.66261 52.2143 1.34477 49.0327 0.470108 44.8234C0.109311 43.1506 0.0109121 41.445 0.0109121 39.7285C0.0218453 35.9019 0.0109121 32.0752 0.0218453 28.2596ZM40.442 45.8074C40.442 45.6653 40.3436 45.5778 40.2889 45.4685C39.786 44.5501 39.4799 43.5989 39.786 42.5493C39.9172 42.112 39.8079 41.9698 39.3159 41.9808C31.7501 42.0026 24.1843 41.9917 16.6076 41.9917C16.6185 41.7621 16.7934 41.6528 16.9465 41.5325C17.4822 41.1061 18.0945 40.9421 18.7723 40.9421C25.9445 40.953 33.1167 40.9421 40.2999 40.9421C41.0652 40.9421 41.2511 40.7672 41.2511 40.0346C41.2401 30.7305 41.2183 21.4263 41.2511 12.1221C41.262 10.1323 39.5783 8.80934 37.9711 8.82027C31.3018 8.87494 24.6435 8.864 17.9742 8.8312C16.1593 8.82027 14.6724 10.1651 14.6724 12.1002C14.6614 22.7383 14.6614 33.3654 14.6614 44.0034C14.6614 44.1455 14.6614 44.2767 14.727 44.4298C15.4924 46.4634 17.0012 47.3271 19.0019 47.3162C25.4088 47.2615 31.8266 47.2943 38.2335 47.2943C38.9988 47.2943 39.7641 47.2834 40.5295 47.2834C40.9777 47.2834 41.2729 47.0756 41.2948 46.6274C41.3167 46.2119 41.0761 45.9495 40.6716 45.862C40.5841 45.8293 40.5185 45.8183 40.442 45.8074Z",
    fill: "url(#paint0_linear_778_8149)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_778_8149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.442 45.8074C40.5185 45.8183 40.5841 45.8183 40.6607 45.8402C41.0761 45.9277 41.3167 46.1901 41.2839 46.6055C41.2511 47.0538 40.9668 47.2615 40.5185 47.2615C39.7532 47.2615 38.9879 47.2724 38.2226 47.2724C31.8157 47.2724 25.3979 47.2396 18.991 47.2943C17.0012 47.3052 15.4924 46.4415 14.7161 44.4079C14.6614 44.2658 14.6505 44.1346 14.6505 43.9815C14.6505 33.3435 14.6505 22.7164 14.6614 12.0784C14.6614 10.1432 16.1593 8.79841 17.9633 8.80934C24.6326 8.84214 31.2909 8.85307 37.9602 8.79841C39.5783 8.78747 41.2511 10.1104 41.2401 12.1002C41.2073 21.4044 41.2401 30.7086 41.2401 40.0128C41.2401 40.7453 41.0543 40.9202 40.2889 40.9202C33.1167 40.9202 25.9445 40.9202 18.7614 40.9202C18.0835 40.9202 17.4713 41.0952 16.9356 41.5106C16.7825 41.6309 16.7278 41.773 16.5638 41.9917C16.3452 42.1994 16.2577 42.44 16.214 42.7461C16.1812 42.8663 16.1812 42.8663 16.1593 42.9866C16.05 43.2271 16.0718 43.4677 16.1374 43.7082C16.0937 43.8394 16.1046 43.9597 16.214 44.0471C16.214 44.1127 16.214 44.1893 16.214 44.2549C16.203 44.4954 16.2577 44.6813 16.5201 44.7469C17.0886 45.5231 17.8649 45.8183 18.827 45.8183C22.5662 45.7965 26.3163 45.8183 30.0554 45.8074C33.5322 45.8293 36.9871 45.8183 40.442 45.8074Z",
    fill: "#FD533B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2359 42.768C16.2796 42.4728 16.3999 42.1994 16.6185 41.9917C24.1843 41.9917 31.7501 42.0026 39.3268 41.9808C39.8188 41.9808 39.9172 42.112 39.797 42.5493C39.4908 43.5989 39.797 44.5501 40.2999 45.4685C40.3655 45.5778 40.453 45.6653 40.453 45.8074C36.9981 45.8183 33.5432 45.8183 30.0883 45.8293C26.3491 45.8293 22.599 45.8183 18.8598 45.8402C17.8977 45.8402 17.1324 45.545 16.5529 44.7687C16.5092 44.5719 16.4764 44.3642 16.2468 44.2768C16.2468 44.2112 16.2468 44.1346 16.2468 44.069C16.3671 43.916 16.3233 43.8066 16.1703 43.7301C16.1047 43.4896 16.0937 43.249 16.1921 43.0085C16.2796 42.9429 16.3452 42.8773 16.2359 42.768Z",
    fill: "#FEFEFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_778_8149",
    x: 5.90393,
    y: 8.79834,
    width: 44.1295,
    height: 58.1759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.30255
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.12102
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_778_8149"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.727071
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.290828
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_778_8149",
    result: "effect2_dropShadow_778_8149"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36901
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.547604
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_778_8149",
    result: "effect3_dropShadow_778_8149"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.44208
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.976832
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_778_8149",
    result: "effect4_dropShadow_778_8149"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.56764
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82706
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_778_8149",
    result: "effect5_dropShadow_778_8149"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.37329
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_778_8149",
    result: "effect6_dropShadow_778_8149"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_778_8149",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_778_8149",
    x1: 54.5568,
    y1: -1.95989,
    x2: -0.0000179901,
    y2: 55.9862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECD8BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CEAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_778_8149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0 0.00805664)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.3eadc56574ba1818d91a018897ad92ec.svg";
export { ForwardRef as ReactComponent };